export const batchUpdateLearningResourceSetItem = `
  updateLearningResourceSetItem(input: $learningResourceSetItemInput) {
  
    clientMutationId
    
    learningResourceSet {
      id
      order
    }
  
    errors {
      message
      path
    }
  
  }
`;
